export const paths = ['/documents/daily-reports'];
